import { Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-ai-user-chat',
  templateUrl: './ai-user-chat.component.html',
  styleUrls: ['./ai-user-chat.component.scss'],
})

export class AIUserChatComponent implements OnInit {
  constructor() {}

  goBack() {}

  ngOnInit(): void {
    console.log('AIUserChatComponent');
  }


}
